export default __webpack_public_path__ + "static/media/blackCard.23296d5b.svg";